import { render } from "./EmojiRating.vue?vue&type=template&id=8467a536&scoped=true"
import script from "./EmojiRating.vue?vue&type=script&lang=js"
export * from "./EmojiRating.vue?vue&type=script&lang=js"

import "./EmojiRating.vue?vue&type=style&index=0&id=8467a536&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8467a536"]])

export default __exports__